import React from "react";

function BucketTable_Fault_Click_Imb(props) {
  let { data, field_name } = props;
  return (
    <>
      {(data.length == 0) ? "<tr><td colSpan={2}>No data found</td></tr>" : data.map((x, index) => {
        return (<tr key={x.key}>
          <td scope="row ">{x.key.vehicleId}</td>
          <td >{(x.duration.value).toFixed(2)} </td>
        </tr>)
      })}
    </>
  );
}

export default BucketTable_Fault_Click_Imb;